import { provideAppInitializer } from '@angular/core';

function configurationInitializer() {
  return Promise.all([
    import('./components/art-scroller'),
  ]);
}

export const provideInscomponents = () => provideAppInitializer(() => configurationInitializer());
